import { render, staticRenderFns } from "./GlobalSideMenu.vue?vue&type=template&id=009efeb7&scoped=true"
import script from "./GlobalSideMenu.vue?vue&type=script&lang=ts"
export * from "./GlobalSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSideMenu.vue?vue&type=style&index=0&id=009efeb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009efeb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009efeb7')) {
      api.createRecord('009efeb7', component.options)
    } else {
      api.reload('009efeb7', component.options)
    }
    module.hot.accept("./GlobalSideMenu.vue?vue&type=template&id=009efeb7&scoped=true", function () {
      api.rerender('009efeb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/GlobalSideMenu.vue"
export default component.exports